<template>
  <MapMain/>
</template>

<script>
import MapMain from '@/components/MapMain'

export default {
  components: {
    MapMain
  }
}
</script>
